import { BottomSection } from './landing-page';

export type ConfigType = {
  env: {
    siteId: string;
    captcha_security: number;
  };
  site: {
    name: string;
    domain: string;
    hostUrl: string;
    title: string;
    description: string;
    supportEmail: string;
    noReplyEmail: string;
    helpPageUrl: string;
    privacyPageUrl: string;
    termsPageUrl: string;
  };
  brand: {
    logoUrl: string;
    whiteLogoUrl: string;
    monogramUrl: string;
    textLogoUrl: {
      webp: string;
      png: string;
    };
    watermark: {
      horizontal: string;
      vertical: string;
      square: string;
      rectangle: string;
    };
    assets: {
      inviteTeamEmailBanner: string;
      accountActivatedEmailBanner: string;
    };
    blueLogoURL: string;
    greenLogoURL: string;
    purpleLogoURL: string;
    blueMonogramLogoURL: string;
    greenMonogramLogoURL: string;
    purpleMonogramLogoURL: string;
  };
  features: {
    blogs: boolean;
    shows: boolean;
    affiliate: boolean;
    tools: boolean;
    creatorclub: boolean;
    fbcommunity: boolean;
    referral: boolean;
    socialLogin: boolean;
    templateShare: boolean;
    interlinkedPages: boolean;
    content: boolean;
    notificationAlert: boolean;
    ltdDeal: boolean;
    hiring: boolean;
  };
  account: {
    referrer: string;
    source: string;
  };
  social: SocialLinksType;
  payments: {
    watermarkAssetUrl: string;
  };
  experimentIds: {
    SIGNUP_OVERLAY: string;
    SOCIAL_SIGNUP: string;
    NEW_AUTH_MODAL: string;
  };
  maintenance: {
    showNotification: boolean;
    maintenanceStartDate: string;
  };
  experiments: {
    moduleFederation: {
      cookie: string;
      accountLowerBound: number;
      ignoredAccounts: number[];
      whitelistedAccounts: [];
      percentTargetUsers: number;
      percentTargetOldUsers: number;
    };
  };
};

export type SocialLinksType = {
  twitterHandle: string;
  twitter: string;
  facebook: string;
  instagram: string;
  youtube: string;
  linkedin: string;
  pinterest: string;
  reviews: boolean;
};

export interface PosterType {
  webpURL: string;
  defaultURL: string;
}

export enum BaseAppType {
  AI = 'AI',
  STUDIO = 'STUDIO',
}

export interface SEOType {
  CanonicalURL: string;
  Description: string;
  Hreflang: Record<string, any>[];
  Keywords: string;
  Meta: Record<string, any>[];
  RobotFollow: string | null;
  RobotIndex: string | null;
  Title: string;
  id: number;
}

export enum HeadingStyleType {
  Plain = 'Plain',
  Highlighted = 'Highlighted',
}

export interface HeroSectionTitleType {
  heading1: string;
  heading2: string;
  heading3: string;
  heading4: string;
  heading1Style: HeadingStyleType;
  heading2Style: HeadingStyleType;
  heading3Style: HeadingStyleType;
  heading4Style: HeadingStyleType;
}

export interface SideTextType {
  highlightedText: string | null;
  plainText1: string | null;
  plainText2: string | null;
}

export interface HeaderWithoutPosterType {
  Heading: HeroSectionTitleType;
  SideText: SideTextType;
}

export interface ImageResponseType {
  hash: string;
  height: number;
  id: number;
  mime: string;
  name: string;
  previewUrl: string;
  provider: string;
  provider_metadata: any;
  size: number;
  updated_at: string;
  url: string;
  width: number;
  alternativeText: string;
}

export interface ToolCard {
  image: ImageResponseType;
  plainTitle1: string;
  plainTitle2: string;
  CTAUrl: string;
}

export interface ToolsRootResponseType {
  SEO: SEOType;
  BaseAppType: BaseAppType | null;
  HeroSection: HeaderWithoutPosterType | null;
  ToolCards: ToolCard[] | null;
  ToolBox1: ToolBoxType | null;
  ToolBox2: ToolBoxType | null;
  BottomSection: BottomSection | null;
}

export interface LinkType {
  URL: string;
  Name: string;
}

export interface ToolBoxType {
  plainHeading: string;
  highlightedHeading: string;
  links: LinkType[];
}
